import { render, staticRenderFns } from "./InfoText.vue?vue&type=template&id=decdd34a"
import script from "./InfoText.vue?vue&type=script&lang=js"
export * from "./InfoText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports